import { render, staticRenderFns } from "./AccessoriesModal.vue?vue&type=template&id=47a8c723&"
import script from "./AccessoriesModal.vue?vue&type=script&lang=js&"
export * from "./AccessoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./AccessoriesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports